import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from './GridLayoutModuleWrapper.module.css';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import { gridLayoutComponentMap } from './gridLayoutComponentMap';

export const GridLayoutModuleWrapper = observer(React.forwardRef(
  ({ moduleId, children, layoutType, style, className, ...props }, ref) => {
    const { layoutStore } = useWebsocketStore();
    const module = layoutStore.currentLayouts[layoutType].moduleList[moduleId];
    const InnerComponent = gridLayoutComponentMap[module.moduleType];
    return (
      <div
        data-grid={module.data}
        style={{ ...style }}
        className={[styles.wrapper, className].join(' ')}
        ref={ref}
        {...props}
      >
        <InnerComponent
          widthRef={ref}
          details={module.details}
          moduleId={moduleId}
          layoutType={layoutType}
          data={module.data}
        />
        {children}
      </div>
    );
  },
  { forwardRef: true }
));
